import { IImageProps } from 'telia-front-react';

export const getPersonalOfferImageProps = (imageUrl: string, mobileImageUrl?: string): IImageProps => {
  const width: number = 360;
  const sizes: string[] = ['360', '720', '1080'];
  const desktopSizes: string[] = ['1160', '2320'];

  if (!(imageUrl.includes('res.cloudinary.com') || imageUrl.startsWith('http'))) {
    const srcset = sizes.map((size) => getCloudinaryUrl(mobileImageUrl || imageUrl, size)).join(', ');
    const desktopSrcset = desktopSizes.map((size) => getCloudinaryUrl(imageUrl, size)).join(', ');
    return {
      sources: [
        {
          minWidth: '1320px',
          srcset: desktopSrcset,
        },
        {
          minWidth: '1000px',
          srcset: desktopSrcset,
        },
      ],
      srcset,
      width,
      role: 'presentation',
    };
  }
  return { src: imageUrl, width, role: 'presentation' };
};

const getCloudinaryUrl = (imageUrl: string, size: string) =>
  `https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_${size}${imageUrl} ${size}w`;
